export default {
	CREATE_PURCHASE_ORDER_CHANGE_LOG: "CREATE_PURCHASE_ORDER_CHANGE_LOG",
	SET_LOADING: "SET_LOADING",
};
